import {
  MachinesApi,
  ReportingMelcoMachineStatisticsModelsGroupListItem,
  useAPIQuery,
  useTable,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTableErrorComponent } from "../table/useTableErrorComponent";

export const useMachines = () => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<ReportingMelcoMachineStatisticsModelsGroupListItem>({
    pageSize: 10,
  });

  const query = useAPIQuery(
    MachinesApi,
    ["machines", currentPage, pageSize, filters, sortBy(), searchQuery],
    async (api: MachinesApi) => {
      const response = await api.statisticsMachinesSearch({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        searchText: !isEmpty(searchQuery) ? searchQuery : undefined,
      });

      setTotal(response.total);

      return response.list;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,

    ...query,
    
  };
};
